export const findHiglightedFileUrl: (files: string[] | undefined) => string = (
  files?: string[]
) => {
  return files?.find((file) => file?.includes('documentParsed')) ?? '';
};
